import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { AlertCircle, ArrowLeft } from 'lucide-react';

export default function CheckoutPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="checkout-page">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center mx-auto mb-4">
          <AlertCircle className="w-8 h-8 text-amber-500" />
        </div>
        <h1 className="text-2xl font-bold text-[#1A1A1A] mb-3">Checkout Coming Soon</h1>
        <p className="text-[#57534E] leading-relaxed mb-2">
          Direct checkout is available only for standardized SKUs with simple installation.
        </p>
        <p className="text-sm text-[#A8A29E] mb-6">
          Currently, all purchases are processed through our RFQ flow. Submit your Quote Cart and our team will provide a formal invoice.
        </p>
        <div className="flex flex-col gap-3">
          <Link to="/cart">
            <Button className="w-full rounded-full bg-[#0061DD] text-white gap-2" data-testid="back-to-cart-btn">
              <ArrowLeft className="w-4 h-4" /> Back to Quote Cart
            </Button>
          </Link>
          <Link to="/products">
            <Button variant="outline" className="w-full rounded-full">Browse Products</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
